import { createSlice } from '@reduxjs/toolkit';

interface InitialStateProps {
  list: {
    data: Record<string, any>[] | null;
    error: string | null;
    isLoading: boolean;
  };
  post: {
    data: Record<string, any> | null;
    error: string | null;
    isLoading: boolean;
  };
  languageLinks: {
    data: Record<string, any> | null;
    error: string | null;
    isLoading: boolean;
  };
}

const initialState: InitialStateProps = {
  list: {
    data: null,
    error: null,
    isLoading: false,
  },
  post: {
    data: null,
    error: null,
    isLoading: false,
  },
  languageLinks: {
    data: null,
    error: null,
    isLoading: false,
  },
};

export const { actions: newsActions, reducer: newsReducer } = createSlice({
  name: 'news',
  initialState,
  reducers: {
    setNewsListRequest: (state) => {
      state.list = {
        data: null,
        error: null,
        isLoading: true,
      };
    },

    setNewsListSuccess: (state, { payload }) => {
      state.list = {
        data: payload.hits,
        error: null,
        isLoading: false,
      };
    },

    setNewsListFailure: (state, { payload }) => {
      state.list = {
        data: null,
        error: payload,
        isLoading: false,
      };
    },

    setNewsPostRequest: (state) => {
      state.post = {
        isLoading: true,
        data: null,
        error: null,
      };
    },

    setNewsPostSuccess: (state, { payload }) => {
      state.post = {
        isLoading: false,
        data: payload,
        error: null,
      };
    },

    setNewsPostFailure: (state, { payload }) => {
      state.post = {
        isLoading: false,
        data: null,
        error: payload,
      };
    },

    setLanguageLinksRequest: (state) => {
      state.languageLinks = {
        isLoading: true,
        data: null,
        error: null,
      };
    },

    setLanguageLinksSuccess: (state, { payload }) => {
      state.languageLinks = {
        isLoading: false,
        data: payload,
        error: null,
      };
    },
    setLanguageLinksFailure: (state, { payload }) => {
      state.languageLinks = {
        isLoading: false,
        data: null,
        error: payload,
      };
    },
  },
});
